import { useReactiveVar } from '@apollo/client'
import { deliverySlotReservationIdVar } from 'services/DeliverySlot/utils/local-storage'

/** Returns the reservation id of the current delivery slot reservation, if any */
export const useDeliverySlotReservationId = (): string | null => {
  return useReactiveVar(deliverySlotReservationIdVar)
}
